import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import CadastrarExames from './views/CadastrarExames';
import CalcularReceitas from './views/CalcularReceitas';
import ConsultarAlimentos from './views/ConsultarAlimentos';
import ConsultarAlimentosDesc from './views/ConsultarAlimentosDesc';
import DiarioAlimentar from './views/DiarioAlimentar';
import Home from './views/Home';
import Lembretes from './views/Lembretes';
import Relatorios from './views/Relatorios';
import SAC from './views/SAC';
import Info from './views/Info';
import Login from './views/Login';
import Cadastro from './views/Cadastro';

const App = () => {
    return (
        <Router>
            <Routes>
                <Route path="/login" exact element={<Login/>}/>
                <Route path="/cadastro" exact element={<Cadastro/>}/>
                <Route path="/" exact element={<Home/>}/>
                <Route path="/diario" exact element={<DiarioAlimentar/>}/>
                <Route path="/consultar-alimentos/:day/:ref" exact element={<ConsultarAlimentos/>}/>
                <Route path="/consultar-alimentos/:recipeId" exact element={<ConsultarAlimentos/>}/>
                <Route path="/consultar-alimentos" exact element={<ConsultarAlimentos/>}/>
                <Route path="/consultar-alimentosDesc/:day/:ref/:categorie/:catname" exact element={<ConsultarAlimentosDesc/>}/>
                <Route path="/consultar-alimentosDesc/:recipeId/:categorie/:catname" exact element={<ConsultarAlimentosDesc/>}/>
                <Route path="/consultar-alimentosDesc/:categorie/:catname" exact element={<ConsultarAlimentosDesc/>}/>
                <Route path="/cadastrar-exames" exact element={<CadastrarExames/>}/>
                <Route path="/calcular-receitas" exact element={<CalcularReceitas/>}/>
                <Route path="/calcular-receitas/:recipeId" exact element={<CalcularReceitas/>}/>
                <Route path="/calcular-receitas/:day/:ref" exact element={<CalcularReceitas/>}/>
                <Route path="/lembretes" exact element={<Lembretes/>}/>
                <Route path="/relatorios" exact element={<Relatorios/>}/>
                <Route path="/sac" exact element={<SAC/>}/>
                <Route path="/info" exact element={<Info/>}/>
            </Routes>
        </Router>
    )
}

export default App